var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V0.75C0 0.558333 0.075 0.385417 0.225 0.23125C0.375 0.0770834 0.55 0 0.75 0H9.25C9.44167 0 9.61458 0.0770834 9.76875 0.23125C9.92292 0.385417 10 0.558333 10 0.75V7.25C10 7.44167 9.92292 7.61458 9.76875 7.76875C9.61458 7.92292 9.44167 8 9.25 8H2L0 10ZM0.75 8.1875L1.6875 7.25H9.25V0.75H0.75V8.1875ZM0.75 0.75V7.25V8.1875V0.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.acbd0278a79596c4d4077b6aedf74490.svg";
export { ForwardRef as ReactComponent };